import { Action } from '../actions/contests';

const defaultState = {
  isFetching: false,
  isFetchingWinners: false,
  activeContest: {},
  recentWinners: [],
};

export default function contestsReducer(state = defaultState, action) {
  const body = action?.payload;

  switch (action?.type) {
    case Action.Contests.FetchCurrentContestPending:
      return {
        ...state,
        isFetching: true,
      };

    case Action.Contests.FetchCurrentContestCompleted:
      return {
        ...state,
        isFetching: false,
        activeContest: body && body.contest,
      };

    case Action.Contests.FetchRecentWinnersPending:
      return {
        ...state,
        isFetchingWinners: true,
      };

    case Action.Contests.FetchRecentWinnersCompleted:
      return {
        ...state,
        isFetchingWinners: false,
        recentWinners: body && body.recentWinners,
      };

    default:
      return state;
  }
}
